// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UPEl","colBig":"styles_colBig__1R-hn","colSmall":"styles_colSmall__KpxW2"};